import { motion } from "framer-motion";
import { MANIFESTO } from "../data";

const DRIVER_IMG =
  "https://images.unsplash.com/photo-1611448746128-7c39e03b71e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const WhyUs = () => (
  <section id="why" data-testid="why-section" className="relative bg-ink text-white py-20 sm:py-28 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-start">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-sun mb-3">Why DS Cabs</p>
        <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
          Then you found <span className="text-sun">us.</span>
        </h2>

        <div className="mt-10 space-y-2">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.n}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`manifesto-${m.n}`}
              className="group flex gap-5 py-6 border-t border-white/15"
            >
              <span className="font-display font-extrabold text-2xl text-brandred shrink-0 w-12">{m.n}</span>
              <div>
                <h3 className="font-display font-bold text-2xl tracking-tight text-white group-hover:text-sun transition-colors">{m.title}</h3>
                <p className="mt-2 text-white/60 leading-relaxed">{m.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="relative lg:sticky lg:top-28"
      >
        <div className="relative border-2 border-sun">
          <img src={DRIVER_IMG} alt="Professional driver" className="w-full h-[420px] lg:h-[560px] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
        </div>
        <div className="grid grid-cols-2 gap-3 mt-3">
          {[
            ["Clean & Safe", "Comfortable rides"],
            ["Pro Drivers", "Local & trusted"],
            ["Cash / Card / E-Transfer", "Pay your way"],
            ["Local & Long Distance", "Anywhere you need"],
          ].map(([t, s]) => (
            <div key={t} className="bg-white text-ink p-4 border-2 border-sun">
              <p className="font-display font-bold text-base leading-tight">{t}</p>
              <p className="text-xs text-ink/60 mt-1">{s}</p>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
